import { render } from "./accordion-snippet.vue?vue&type=template&id=13c7f711"
import script from "./accordion-snippet.vue?vue&type=script&lang=js"
export * from "./accordion-snippet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__